package com.eladfinish.bible.contest.ui.models

data class AlternateRowData(
    val title: String,
    val isBold: Boolean = false,
    val subtitle: String? = null,
)
